import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuHeaderProps } from './MenuHeaderProps.types';
import styles from './MenuHeader.module.css';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import { useNavigate } from 'react-router-dom';
import { useSTKContext } from '@/context/context';
import useFranchiseeAlias from '@/utils/useFranchiseeAlias/useFranchiseeAlias';
import classNames from 'classnames';

const MenuHeader: FC<MenuHeaderProps> = ({ data, navigateUrl }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { storesAndGroups } = useSTKContext();
  const { alias } = useFranchiseeAlias();
  const [hasHorizontalScrollbar, setHasHorizontalScrollbar] = useState(false);
  const [mobileViewScreen, setMobileViewScreen] = useState(false);

  const getTotalStoresGroupSelected = () => {
    let totalStoreCount = 0;
    storesAndGroups?.storeGroups?.forEach((group) => {
      totalStoreCount += group.stores.length;
    });
    return totalStoreCount;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setHasHorizontalScrollbar(true);
      } else {
        setHasHorizontalScrollbar(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setMobileViewScreen(true);
      } else {
        setMobileViewScreen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const getManageMenuButton = () => (
    <Button
      variant={ButtonVariants.Primary}
      onClick={() => {
        navigate(navigateUrl);
      }}
      disabled={storesAndGroups?.stores?.length === 0 || storesAndGroups?.storeGroups?.length === 0}
    >
      {t('menu.manageMenuButton')}
    </Button>
  );

  const getStoreSelectedLabel = () => (
    <div className={styles.storesSelected}>
      {t('menu.storesSelected', {
        count: storesAndGroups?.stores?.length || getTotalStoresGroupSelected(),
        size: data.length,
      })}
    </div>
  );

  return (
    <div
      className={classNames(hasHorizontalScrollbar ? styles.stickyHeaderShadow : styles.stickyHeader, {
        [styles.withAlias]: !alias,
      })}
    >
      <div className={styles.menuTitleHeader}>
        <div className={styles.leftHeaderLabel}>
          <div className={styles.storeMenusText}>{t('menu.selectStoreLabel')}</div>
        </div>
        {!hasHorizontalScrollbar && !mobileViewScreen && (
          <div className={styles.labelRightButton}>
            {getManageMenuButton()}
            {getStoreSelectedLabel()}
          </div>
        )}
        {(hasHorizontalScrollbar || mobileViewScreen) && (
          <div className={styles.labelLeftButton}>
            {getStoreSelectedLabel()}
            {getManageMenuButton()}
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuHeader;
